import React, { FC } from 'react';

import {
	EvFilters,
	IFilterDefinition,
	IFilterValues,
	TABLE_FILTERS_SR_SUMMARY,
	TFilterOptions
} from '@evinced-private/ui-common';

import { IFilterOptions } from '../../helpers/FiltersHelper';

import './UsersTableFilters.scss';

type TFilterTypes = 'text' | 'select';

interface IUsersTableFiltersProps {
	filterOptions: IFilterOptions;
	filterValues: IFilterOptions;
	onApply: (filterValues: IFilterOptions) => void;
	onClear: () => void;
}

export const UsersTableFilters: FC<IUsersTableFiltersProps> = ({
	filterOptions,
	filterValues,
	onApply,
	onClear
}) => {
	const initialValues: IFilterValues = {
		text: { freeSearch: filterValues?.freeSearch || '' },
		select: {
			userType: filterValues?.userType || [],
			active: filterValues?.active || []
		}
	};

	const handleApply = (appliedFilters: IFilterValues): void => {
		const flatFilters: IFilterOptions = {
			freeSearch: appliedFilters?.text?.freeSearch || '',
			userType: appliedFilters?.select?.userType || [],
			active: appliedFilters?.select?.active || []
		};
		onApply(flatFilters);
	};

	const filterDefinitions: IFilterDefinition[] = [
		{
			id: 'freeSearch',
			label: 'Search',
			filterType: 'text',
			defaultValue: '',
			srTitle: 'Search users'
		},
		{
			id: 'userType',
			label: 'User Type',
			filterType: 'select' as TFilterTypes,
			defaultValue: [],
			srTitle: 'Filter by user type',
			componentProps: {
				id: 'userType',
				label: 'User Type',
				isMultiple: true,
				placeholder: 'Select User Type',
				allSelectedPlaceholder: 'All User Types',
				someItemsSelectedText: (count: number) => `User Types (${count})`
			}
		},
		{
			id: 'active',
			label: 'Status',
			filterType: 'select',
			defaultValue: [],
			srTitle: 'Filter by status',
			componentProps: {
				id: 'active',
				label: 'Status',
				isMultiple: true,
				placeholder: 'Select Status',
				allSelectedPlaceholder: 'All Status',
				someItemsSelectedText: (count: number) => `Statuses (${count})`
			}
		}
	];

	const renderSrSummary = (): JSX.Element => {
		const selectedStatusOptions = filterValues?.active?.length;
		const selectedTypeOptions = filterValues?.userType?.length;
		const allStatusOptions = filterOptions?.active?.length;
		const allTypeOptions = filterOptions?.userType?.length;

		const statusText =
			selectedStatusOptions === allStatusOptions || !filterValues ? 'all' : selectedStatusOptions;
		const typesText =
			selectedTypeOptions === allTypeOptions || !filterValues ? 'all' : selectedTypeOptions;

		return (
			<div id={TABLE_FILTERS_SR_SUMMARY} className="sr-only">
				Active users table filter results:
				{`User Status: ${statusText},`}
				{`User types: ${typesText}`}
			</div>
		);
	};

	const convertToFilterOptions = (options: IFilterOptions): TFilterOptions => ({
		userType: options?.userType || [],
		active: options?.active || []
	});

	return (
		<div className="users-table-filters">
			<EvFilters
				filterDefinitions={filterDefinitions}
				initialValues={initialValues}
				filterOptions={convertToFilterOptions(filterOptions)}
				onApply={handleApply}
				onReset={onClear}
				isFilterOptionsLoaded
				isInitialValuesLoaded
			/>
			{renderSrSummary()}
		</div>
	);
};
